import { FormattedMessage } from "react-intl";

import { ReactComponent as PickupPackageIcon } from "assets/images/iconsV2/package-up.svg";
import { ReactComponent as DeliveryPackageIcon } from "assets/images/iconsV2/package-right.svg";
import Badge from "components/v2/Badge/Badge";

interface StopInfoProps {
  stop: {
    stop_type: string; // "Pickup" or "Dropoff"
    address_details: {
      street_address?: string;
      street_address_line_two?: string;
      city?: string;
      state?: string;
      country?: string;
      zipcode?: string;
    };
  };
}

export default function StopInfo({ stop }: StopInfoProps) {
  const isPickup = stop.stop_type === "Pickup";
  const { street_address, street_address_line_two, city, state, country, zipcode } = stop.address_details || {};

  return (
    <div className="stop-info d-flex align-items-start gap-xs">
      <div className="mr-md">
        <Badge
          type="status-badge"
          size="sm"
          color={isPickup ? "indigo" : "success"}
          variant="icon-leading"
          label={
            isPickup ? (
              <FormattedMessage id="general.pickup" defaultMessage="Pickup" />
            ) : (
              <FormattedMessage id="general.delivery" defaultMessage="Delivery" />
            )
          }
          icon={isPickup ? <PickupPackageIcon stroke="#6172F3" /> : <DeliveryPackageIcon stroke="#079455" />}
        />
      </div>

      <div>
        <div>{street_address}</div>
        {street_address_line_two && <div>{street_address_line_two}</div>}
        <div>
          {city}
          {city && zipcode && ", "}
          {zipcode}
        </div>
        <div>
          {state}
          {state && country && ", "}
          {country}
        </div>
      </div>
    </div>
  );
}
